define('views/pages/favorites/goods/index',['require','jquery','underscore','mediator','views/base/page','lib/utils','views/pages/favorites/goods/navbar','views/pages/favorites/goods/table','views/filter/index','text!templates/pages/favorites/goods/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        mediator = require('mediator'),
        PageView = require('views/base/page'),
        utils = require('lib/utils'),
        FavoritesGoodsNavbarView = require('views/pages/favorites/goods/navbar'),
        FavoritesGoodsTableView = require('views/pages/favorites/goods/table'),
        FilterView = require('views/filter/index'),
        template = require('text!templates/pages/favorites/goods/index.ejs');

    var FavoritesGoodsView = PageView.extend({
        autoRender: true,
        template: template,
        windowResize: true,
        region: 'goods',
        regions: {
            'favorites-goods-table': '#favorites-goods-table-container',
            'favorites-goods-navbar': '#favorites-goods-navbar-container',
            'favorites-goods-filter': '#favorites-goods-filter-container'
        },
        listen: {
            'afterLoad model': 'render'
        },

        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            mediator.setBreadcrumb(['favorites'], 'Товары');
        },

        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('navbar', new FavoritesGoodsNavbarView({ model: this.model }));
            this.subview('filter', new FilterView({ model: this.model.filter, region: 'favorites-goods-filter' }));
            this.subview('table', new FavoritesGoodsTableView({ collection: this.model.goods, model: this.model }));
        }
    });

    return FavoritesGoodsView;
});


